import HeaderIconEspacePrive from '../../assets/header_espace-prive.svg';
import { ConnectedHoc, NotConnectedHoc } from '../../components';
import {
    ActuArticleCreate,
    ActuArticleEdit,
    ActuArticleList,
    ActuArticleShow,
    ActuList,
    ActuRubriqueCreate,
    ActuRubriqueEdit,
    ActuRubriqueList,
    ActuTagCreate,
    ActuTagEdit,
    ActuTagList,
    Affiliates,
    BiaEnLigne,
    ContactForm,
    CotisationsCall,
    DecryptRHArticleCreate,
    DecryptRHArticleEdit,
    DecryptRHArticleList,
    DecryptRHArticleShow,
    DecryptRHList,
    DecryptRHRubriqueCreate,
    DecryptRHRubriqueEdit,
    DecryptRHRubriqueList,
    DecryptRHTagCreate,
    DecryptRHTagEdit,
    DecryptRHTagList,
    FAQList,
    FAQQuestionCreate,
    FAQQuestionEdit,
    FAQQuestionList,
    FAQRubriqueCreate,
    FAQRubriqueEdit,
    FAQRubriqueList,
    FAQTagCreate,
    FAQTagEdit,
    FAQTagList,
    Master,
    MentionsLegales,
    RadiationForm,
    ResetPassword,
    Signin,
    UsersList,
} from '../../pages';
import Toolbox from '../../pages/Toolbox';
// import HeaderIconAccesUtilisateurs from '../../assets/header_utilisateur.svg';
import HeaderIconAffiliations from '../../assets/header_affiliation.svg';
// import HeaderIconAssures from '../../assets/header_assures.svg';
import HeaderIconContact from '../../assets/header_contact.svg';
import HeaderIconCotisations from '../../assets/header_cotisations.svg';
import HeaderIconDocumentation from '../../assets/header_documentation.svg';
import { ArticleModeRouteNames } from './Article';
// import HeaderIconGaranties from '../../assets/header_garanties.svg';
import PageHeaderTitleIncapacite from 'features/dossierIncapacite/components/PageHeaderTitleIncapacite';
import DemiseDeclaration from 'pages/Affiliations/Demise';
import DeclareIncapacity from 'pages/Affiliations/Incapacity';
import PageFormulaireDeclaration from 'pages/ArretDeTravail/FormulaireDeclaration/PageFormulaireArretTravail';
import PageFormulaireDeclarationSearch from 'pages/ArretDeTravail/FormulaireDeclaration/PageSearch';
import PageArretTravailHistory from 'pages/ArretDeTravail/PageHistorique';
import PageArretTravailHome from 'pages/ArretDeTravail/PageHome';
import PageLidlDocument from 'pages/ArretDeTravail/PageLidlDocument';
import { BoiteAIdee } from 'pages/BoiteAIdee';
import { DocumentationPage } from 'pages/Documentation';
import { GuidePage } from 'pages/Guide';
import NewPassword from 'pages/NewPassword';
import Page404 from 'pages/Page404';
import AffiliatesPrev from 'pages/Prevoyance/Affiliates';
import DetailDossierPrev from 'pages/Prevoyance/Dossier';
import ListDossierPrev from 'pages/Prevoyance/List';
import SigninBackOffice from 'pages/Signin/backoffice';
import Dashboard from 'pages/Statistiques/Dashboard';
import { TutosList } from 'pages/Tutos';
import { TUTOQuestionCreate, TUTOQuestionEdit, TUTOQuestionList } from 'pages/Tutos/Question';
import TUTORubriqueCreate from 'pages/Tutos/Rubrique/Create';
import TUTORubriqueEdit from 'pages/Tutos/Rubrique/Edit';
import TUTORubriqueList from 'pages/Tutos/Rubrique/List';
import UpdatePassword from 'pages/UpdatePassword';
import UsersPageAdd from 'pages/Utilisateurs/Add';
import FinaliseAccount from 'pages/Utilisateurs/FinaliseAccount';
import UsersPageUpdate from 'pages/Utilisateurs/Update';
import UserWelcome from 'pages/Utilisateurs/Welcome';
import HeaderIconRadiations from '../../assets/header_radiations.svg';
import HeaderIconStatistiques from '../../assets/header_statistiques.svg';
//import { MaintenanceArret } from 'pages/Maintenance';
// import HeaderIconStatistiques from '../../assets/header_statistiques.svg';

export interface Route {
    name: string;
    icon?: string;
    role?: string[];
    path: string;
    category?: string;
    description?: JSX.Element;
    component?: React.ComponentType;
    iframeId?: string;
}

// After removing iframes, use routes to generate sidebar elements
export const routes: Route[] = [
    {
        name: 'Signin',
        icon: '',
        path: '/connexion',
        component: NotConnectedHoc(Signin),
    },
    {
        name: 'Backoffice',
        icon: '',
        path: '/connexion_backoffice',
        component: NotConnectedHoc(SigninBackOffice),
    },
    {
        name: 'ResetPassword',
        icon: '',
        path: '/mdp-oublie',
        component: NotConnectedHoc(ResetPassword),
    },
    {
        name: 'ForceChangePasswordNotification',
        icon: '',
        path: '/mdp-update',
        component: NotConnectedHoc(UpdatePassword),
    },
    {
        name: 'UpdatePasswordForm',
        icon: '',
        path: '/mdp-new-pass',
        component: NewPassword,
    },
    {
        name: 'FinalizeAccount',
        icon: '',
        path: '/finalise-account',
        component: NotConnectedHoc(FinaliseAccount),
    },
    {
        path: '/',
        icon: HeaderIconEspacePrive,
        name: 'privateSpace.label',
        description: (
            <span>
                Bienvenue sur votre <span style={{ color: 'white' }}>espace entreprise</span>
            </span>
        ),
        component: ConnectedHoc(Master),
    },
    {
        path: '/affiliations/bias',
        icon: HeaderIconAffiliations,
        name: 'affiliations.contrat.label',
        role: ['ROLE_SEE_BIA'],
        category: 'affiliations.label',
        description: <span>Retrouvez ci-dessous les BIA en attente de validation de votre part</span>,
        component: ConnectedHoc(BiaEnLigne),
    },
    {
        path: '/affiliations',
        icon: HeaderIconAffiliations,
        name: 'affiliations.affiliates.label',
        role: ['ROLE_VALID_ASSURED', 'ROLE_HISTORY_ASSURED'],
        category: 'affiliations.label',
        description: <span>Retrouvez ci-dessous la liste des affiliés</span>,
        component: ConnectedHoc(Affiliates),
    },
    {
        path: '/radiations/:codAffilie/:codSouscrip',
        icon: HeaderIconRadiations,
        role: ['ROLE_RADIATION'],
        name: 'affiliations.radiate.worker.label',
        component: ConnectedHoc(RadiationForm),
    },

    {
        path: '/cotisations',
        icon: HeaderIconCotisations,
        name: 'cotisations.call.label',
        role: ['ROLE_CONTRIBUTION_SEE', 'ROLE_CONTRIBUTION_DECLARE', 'ROLE_CONTRIBUTION_SEND'],
        category: 'cotisations.label',
        description: <span>Retrouvez ci-dessous l'historique des cotisations de vos différents contrats</span>,
        component: ConnectedHoc(CotisationsCall),
    },
    {
        path: '/arrets/create',
        icon: HeaderIconAffiliations,
        name: 'workStopping.list',
        category: 'rtt.label',
        description: <span>Liste des Arrets de travail</span>,
        iframeId: 'c-4-A20',
        role: ['ROLE_ADD_WORK_STOPPING'],
    },
    // {
    //     path: '/arrets/create',
    //     icon: HeaderIconAffiliations,
    //     //name: 'workStopping.list',
    //     name: 'Arrêt de travail',
    //     category: 'rtt.label',
    //     description: <span>En maintenance</span>,
    //     //iframeId: 'c-4-A20',
    //     component: ConnectedHoc(FormulaireArretTravail),
    //     role: ['ROLE_ADD_WORK_STOPPING'],
    // },
    // --------------- new
    {
        path: '/arrets/home',
        icon: HeaderIconAffiliations,
        //name: 'workStopping.list',
        name: 'Arrêt de travail',
        category: 'rtt.label',
        description: <span>Accueil arrêt de travail</span>,
        //iframeId: 'c-4-A20',
        component: ConnectedHoc(PageArretTravailHome),
        role: ['ROLE_ADD_WORK_STOPPING'],
    },
    {
        path: '/arrets/search',
        icon: HeaderIconAffiliations,
        //name: 'workStopping.list',
        name: 'Déclarer un arrêt initial',
        category: 'Prévoyance',
        description: (
            <span>
                Sélection du contrat <span style={{ color: 'white' }}>et de l'assuré</span>{' '}
            </span>
        ),
        //iframeId: 'c-4-A20',
        component: ConnectedHoc(PageFormulaireDeclarationSearch),
        role: ['ROLE_ADD_WORK_STOPPING'],
    },
    {
        path: '/arrets/declare',
        icon: HeaderIconAffiliations,
        //name: 'workStopping.list',
        name: 'Déclarer un arrêt initial',
        category: 'Prévoyance',
        description: <span>Arrêt de travail </span>,
        //iframeId: 'c-4-A20',
        component: ConnectedHoc(PageFormulaireDeclaration),
        role: ['ROLE_ADD_WORK_STOPPING'],
    },
    {
        path: '/arrets/history',
        icon: HeaderIconAffiliations,
        //name: 'workStopping.list',
        name: 'Arrêt de travail',
        category: 'rtt.label',
        description: <span>Accueil arrêt de travail</span>,
        //iframeId: 'c-4-A20',
        component: ConnectedHoc(PageArretTravailHistory),
        role: ['ROLE_ADD_WORK_STOPPING'],
    },
    {
        path: '/arrets/documents',
        icon: HeaderIconAffiliations,
        //name: 'workStopping.list',
        name: 'Dépôt de fichier',
        category: 'rtt.label',
        description: <span>Déposer un fichier</span>,
        //iframeId: 'c-4-A20',
        component: ConnectedHoc(PageLidlDocument),
        role: ['ROLE_DOCUMENTS_LIDL'],
    },

    // FAQ
    {
        path: '/faq',
        icon: HeaderIconAffiliations,
        name: 'help.faq.label',
        component: ConnectedHoc(FAQList),
    },
    {
        path: '/faq/questions',
        icon: HeaderIconAffiliations,
        name: 'help.faq.question.list',
        component: ConnectedHoc(FAQQuestionList),
    },
    {
        path: '/faq/questions/create',
        icon: HeaderIconAffiliations,
        name: 'help.faq.question.create',
        component: ConnectedHoc(FAQQuestionCreate),
    },
    {
        path: '/faq/questions/edit/:id',
        icon: HeaderIconAffiliations,
        name: 'help.faq.question.edit',
        component: ConnectedHoc(FAQQuestionEdit),
    },
    {
        path: '/faq/rubriques',
        icon: HeaderIconAffiliations,
        name: 'rubrique.list',
        component: ConnectedHoc(FAQRubriqueList),
    },
    {
        path: '/faq/rubriques/create',
        icon: HeaderIconAffiliations,
        name: 'rubrique.create',
        component: ConnectedHoc(FAQRubriqueCreate),
    },
    {
        path: '/faq/rubriques/edit/:id',
        icon: HeaderIconAffiliations,
        name: 'rubrique.edit',
        component: ConnectedHoc(FAQRubriqueEdit),
    },
    {
        path: '/faq/tags',
        name: 'tag.list',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagList),
    },
    {
        path: '/faq/tags/create',
        name: 'tag.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagCreate),
    },
    {
        path: '/faq/tags/edit/:id',
        name: 'tag.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagEdit),
    },

    // TUTOS VIDEOS
    {
        path: '/tutos',
        icon: HeaderIconAffiliations,
        name: 'help.tutos.label',
        component: ConnectedHoc(TutosList),
        category: 'help.label',
        description: (
            <span>
                Liste des tutoriels <span style={{ color: 'white' }}>vidéo</span>
            </span>
        ),
    },
    {
        path: '/tuto/questions',
        icon: HeaderIconAffiliations,
        name: 'help.tuto.question.list',
        component: ConnectedHoc(TUTOQuestionList),
    },
    {
        path: '/tuto/questions/create',
        icon: HeaderIconAffiliations,
        name: 'help.tuto.question.create',
        component: ConnectedHoc(TUTOQuestionCreate),
    },
    {
        path: '/tuto/questions/edit/:id',
        icon: HeaderIconAffiliations,
        name: 'help.tuto.question.edit',
        component: ConnectedHoc(TUTOQuestionEdit),
    },
    {
        path: '/tuto/rubriques',
        icon: HeaderIconAffiliations,
        name: 'rubrique.list',
        component: ConnectedHoc(TUTORubriqueList),
    },
    {
        path: '/tuto/rubriques/create',
        icon: HeaderIconAffiliations,
        name: 'rubrique.create',
        component: ConnectedHoc(TUTORubriqueCreate),
    },
    {
        path: '/tuto/rubriques/edit/:id',
        icon: HeaderIconAffiliations,
        name: 'rubrique.edit',
        component: ConnectedHoc(TUTORubriqueEdit),
    },
    {
        path: '/tuto/tags',
        name: 'tag.list',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagList),
    },
    {
        path: '/tuto/tags/create',
        name: 'tag.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagCreate),
    },
    {
        path: '/tuto/tags/edit/:id',
        name: 'tag.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(FAQTagEdit),
    },
    // GUIDE
    {
        path: '/help/guide',
        name: 'Guide',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(GuidePage),
        category: 'help.label',
    },
    // ACTUALITES
    {
        path: `/${ArticleModeRouteNames['articles']}`,
        name: 'informations.actualites.label',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuList),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/articles`,
        name: 'article.admin',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuArticleList),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/articles/create`,
        name: 'article.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuArticleCreate),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/articles/edit/:id`,
        name: 'article.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuArticleEdit),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/rubriques`,
        name: 'rubrique.admin',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuRubriqueList),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/tags`,
        name: 'tag.list',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuTagList),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/tags/create`,
        name: 'tag.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuTagCreate),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/tags/edit/:id`,
        name: 'tag.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuTagEdit),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/:slug`,
        name: 'article.show',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuArticleShow),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/rubriques/create`,
        name: 'rubrique.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuRubriqueCreate),
    },
    {
        path: `/${ArticleModeRouteNames['articles']}/rubriques/edit/:id`,
        name: 'rubrique.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(ActuRubriqueEdit),
    },
    // DECRYPT
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}`,
        name: 'informations.decrypt_rhs.label',
        description: <span>Retrouvez quelques clés pour décrypter les informations métier</span>,
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHList),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/articles`,
        name: 'article.admin',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHArticleList),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/articles/create`,
        name: 'article.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHArticleCreate),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/articles/edit/:id`,
        name: 'article.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHArticleEdit),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/rubriques`,
        name: 'rubrique.admin',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHRubriqueList),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/tags`,
        name: 'tag.list',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHTagList),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/tags/create`,
        name: 'tag.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHTagCreate),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/tags/edit/:id`,
        name: 'tag.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHTagEdit),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/:slug`,
        name: 'article.show',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHArticleShow),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/rubriques/create`,
        name: 'rubrique.create',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHRubriqueCreate),
    },
    {
        path: `/${ArticleModeRouteNames['decrypt_rhs']}/rubriques/edit/:id`,
        name: 'rubrique.edit',
        icon: HeaderIconAffiliations,
        component: ConnectedHoc(DecryptRHRubriqueEdit),
    },
    // CONTACT
    {
        path: '/contact',
        name: 'contact.label',
        icon: HeaderIconContact,
        component: ConnectedHoc(ContactForm),
        role: ['ROLE_CONTACT'],
    },
    // UTILISATEURS
    {
        name: 'Bienvenue dans votre espace privé',
        icon: HeaderIconEspacePrive,
        path: '/utilisateurs/bienvenue',
        category: 'userAccess.label',
        description: (
            <span>
                Création de <span style={{ color: 'white' }}>mon compte</span>
            </span>
        ),
        component: ConnectedHoc(UserWelcome),
    },
    {
        path: '/utilisateurs',
        name: 'userAccess.users.label',
        icon: HeaderIconContact,
        component: ConnectedHoc(UsersList),
        category: 'userAccess.label',
        description: (
            <span>
                Liste de vos <span style={{ color: 'white' }}>utilisateurs</span>
            </span>
        ),
        role: ['ROLE_EDIT_USER', 'ROLE_LIST_USER'],
    },
    {
        path: '/utilisateurs/ajouter',
        name: 'userAccess.addUser.label',
        icon: HeaderIconContact,
        component: ConnectedHoc(UsersPageAdd),
        category: 'userAccess.label',
        description: (
            <span>
                Ajouter un <span style={{ color: 'white' }}>nouvel utilisateur</span>
            </span>
        ),
        role: ['ROLE_ADD_USER'],
    },
    {
        path: '/utilisateurs/modifier',
        name: 'userAccess.updateUser.label',
        icon: HeaderIconContact,
        component: ConnectedHoc(UsersPageUpdate),
        category: 'userAccess.label',
        description: (
            <span>
                Gestion de mon <span style={{ color: 'white' }}>espace personnel</span>
            </span>
        ),
        //role: ['ROLE_ADD_USER'],
    },
    // STATISTIQUES
    {
        path: '/statistiques',
        name: 'statistics.dashboard.label',
        icon: HeaderIconStatistiques,
        component: ConnectedHoc(Dashboard),
        role: ['ROLE_STATISTIC'],
        category: 'statistics.label',
        description: <span>Principaux indicateurs pour vos contrats santé</span>,
    },
    // BOITE A IDEE
    {
        path: '/boite_a_idees',
        name: 'boiteAIdee.formulaire.label',
        icon: HeaderIconContact,
        component: ConnectedHoc(BoiteAIdee),
        role: ['ROLE_CONTACT'],
        category: 'boiteAIdee.label',
        description: <span>Aidez-nous à améliorer notre site</span>,
    },
    // 404
    {
        path: '/404',
        name: '404',
        component: ConnectedHoc(Page404),
    },

    {
        name: 'userAccess.addUser.label',
        role: ['ROLE_ADD_USER'],
        iframeId: 'c-1-A20',
        path: '/users/create',
    },
    {
        name: 'userAccess.users.label',
        role: ['ROLE_EDIT_USER'],
        iframeId: 'c-2-A20',
        path: '/users/manage',
    },
    {
        path: '/contract/documentation',
        name: 'contract.documentation.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(DocumentationPage),
        role: ['ROLE_CONTACT'],
        category: 'contract.label',
        description: (
            <span>
                Liste de <span style={{ color: 'white' }}>vos documents</span>
            </span>
        ),
    },

    // Dossier incapacite
    {
        path: '/affiliations/indemnisation',
        name: 'compensation.affiliates.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(AffiliatesPrev),
        role: ['ROLE_DOSSIER_PREV'],
        category: 'compensation.label',
        description: <>Liste des sinistres</>,
    },
    {
        path: '/affiliations/:codAffilie/indemnisation',
        name: 'compensation.dossiers.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(ListDossierPrev),
        role: ['ROLE_DOSSIER_PREV'],
        category: 'compensation.label',
        description: <PageHeaderTitleIncapacite />,
    },
    {
        path: '/affiliations/indemnisation/dossiers/:reference',
        name: 'compensation.dossier.detail.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(DetailDossierPrev),
        role: ['ROLE_DOSSIER_PREV'],
        category: 'compensation.label',
        description: (
            <span>
                Dossier <span style={{ color: 'white' }}>d'indemnisation détaillé</span>
            </span>
        ),
    },

    // Déclarer une invalidite
    {
        path: '/affiliations/incapacity',
        name: 'incapacity.declaration.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(DeclareIncapacity),
        role: ['ROLE_DOSSIER_PREV'],
        category: 'compensation.label',
        description: <>Formulaire de déclaration</>,
    },

    // Déclarer un décès
    {
        path: '/affiliations/demise',
        name: 'demise.declaration.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(DemiseDeclaration),
        role: ['ROLE_DOSSIER_PREV'],
        category: 'compensation.label',
        description: <>Formulaire de déclaration</>,
    },

    // Mentions légales
    {
        path: '/mentions_legales',
        name: 'mentions.label',
        icon: HeaderIconDocumentation,
        component: ConnectedHoc(MentionsLegales),
    },

    // Statistiques
    {
        name: 'stats.label',
        path: '/stats',
        iframeId: 'c-16-A20',
        role: ['ROLE_STATISTIC'],
    },
    {
        name: 'profile',
        path: '/profile',
        iframeId: 'A59',
    },
    ...(process.env.NODE_ENV !== 'production'
        ? [
              {
                  name: 'Toolbox',
                  icon: 'fa-toolbox',
                  path: '/toolbox',
                  component: Toolbox,
              },
          ]
        : []),
];
